/**
 * The first import of src/entry-client.tsx: a view-as tab gets its own store before the Supabase client
 * or any page reads localStorage (src/lib/viewAs.ts). It must stay first, and import nothing else.
 */
import { bootViewAs } from './viewAs';

if (typeof window !== 'undefined') bootViewAs(window);
